/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-floating-promises */
import {
  Button,
  Col,
  Divider,
  Form,
  Input,
  PageHeader,
  Popconfirm,
  Row,
  Segmented,
  Select,
} from "antd";
// import Title from "antd/lib/typography/Title";

import React, { useEffect, useState } from "react";
import { type FieldData } from "../MidservicePage/ConfigurationForm";
import { useAppDispatch, useAppSelector } from "../../hooks/hooks";
import { getAvailableZonesAsync } from "../../redux/slices/manageUsers/manageUsersSlice";

import { InstancesTransfer } from "./InstancesTransfer";
import CodeEditor from "@uiw/react-textarea-code-editor";
import { objectToYaml, yamlValidate } from "../../utils/yaml";
import { ApartmentOutlined, ToolOutlined } from "@ant-design/icons";
import { configTemplateBuilder } from "./ConfigTemplateBuilder";
import {
  createPacketConfigurationAsync,
  deployPacketConfigurationAsync,
  retrievePacketConfigurationAsync,
  selectCurrentConfiguration,
  // selectSelectedInstances,
  // setSelectedInstances,
  updatePacketConfigurationAsync,
} from "../../redux/slices/PacketConfiguration/PacketConfigurationSlice";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "antd/lib/form/Form";
import YAML from "yaml";
import { AutoCompleteClient } from "../../components/AutoCompleteClient";
import { type PacketConfigurationRequestType } from "../../redux/slices/PacketConfiguration/PacketConfigurationTypes";

export const SingleConfigurationPage = (): JSX.Element => {
  const [form] = useForm();
  const dispatch = useAppDispatch();
  const currentConfiguration = useAppSelector(selectCurrentConfiguration);
  // const selectedInstances = useAppSelector(selectSelectedInstances);

  const navigate = useNavigate();
  const OPTIONS = ["CsvModule"];
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const filteredOptions = OPTIONS.filter((o) => !selectedItems.includes(o));
  const params = useParams();
  const domain = Form.useWatch("domain", form);
  const network = Form.useWatch("network", form);
  // const name = Form.useWatch("name", form);

  console.log("watch domain", domain);
  // const [networkId, setNetworkId] = useState<number | undefined>(
  //   currentConfiguration?.networkId ?? undefined,
  // );
  useEffect(() => {
    if (form.isFieldsTouched(["domain"])) {
      console.log("isFieldsTouched domain");
      form.setFieldValue("network", undefined);
    }
  }, [domain]);
  useEffect(() => {
    if (form.isFieldsTouched(["network", "domain"]))
      form.setFieldValue("instances", []);
  }, [network]);

  const DeployButtonWithConfirm = ({
    configurationId,
    isDataTouched,
  }: {
    configurationId: number;
    isDataTouched: boolean;
  }): JSX.Element => {
    console.log("DeployButtonWithConfirm", configurationId, isDataTouched);
    if (isDataTouched) {
      return (
        <Popconfirm
          okText={"Да"}
          cancelText={"Нет"}
          title="Сохранить конфигурацию перед применением?"
          onCancel={() => {
            dispatch(deployPacketConfigurationAsync(configurationId));
          }}
          onConfirm={() => {
            form.validateFields().then(() => {
              createNewConfig().then(async () => {
                await dispatch(deployPacketConfigurationAsync(configurationId));
              });
            });
          }}
        >
          <Button key={"deployButton"} icon={<ApartmentOutlined />}>
            Применить
          </Button>
        </Popconfirm>
      );
    }
    return (
      <Button
        onClick={() => {
          dispatch(deployPacketConfigurationAsync(configurationId));
        }}
        key={"deployButton"}
        icon={<ApartmentOutlined />}
      >
        Применить
      </Button>
    );
  };

  useEffect(() => {
    if (params?.packetConfigurationId != null)
      dispatch(
        retrievePacketConfigurationAsync(Number(params.packetConfigurationId)),
      );
  }, [params?.packetConfigurationId]);

  useEffect(() => {
    if (currentConfiguration?.id != null)
      window.history.replaceState(
        null,
        "Heado Telemetry",
        `/admin/configuration/${currentConfiguration?.id}`,
      );
  }, [currentConfiguration?.id]);

  useEffect(() => {
    console.log("currentConfiguration", currentConfiguration);
    form.resetFields();
    if (currentConfiguration != null) {
      const newFields: FieldData[] = [];
      let key: keyof typeof currentConfiguration;
      for (key in currentConfiguration) {
        if (key === "config") {
          newFields.push({
            name: key,
            value: objectToYaml(currentConfiguration[key]),
          });
        } else if (key === "instances") {
          newFields.push({
            name: key,
            value: currentConfiguration[key]?.map((item) => String(item)) ?? [],
          });
        } else if (key === "network") {
          newFields.push({
            name: key,
            value: currentConfiguration[key],
          });
        } else {
          console.log("key", key, currentConfiguration[key]);
          newFields.push({ name: key, value: currentConfiguration[key] });
        }
      }
      console.log("newFields", newFields);
      form.setFields(newFields);
    }
  }, [currentConfiguration]);

  useEffect(() => {
    dispatch(getAvailableZonesAsync());
  }, []);

  const createNewConfig = async (): Promise<any> => {
    console.log("createNewConfig", form.getFieldsValue());
    const newPacketConfiguration: PacketConfigurationRequestType = {
      id: currentConfiguration?.id,
      name: form.getFieldValue("name"),
      domain: form.getFieldValue("domain"),
      networkId: form.getFieldValue("network").id,
      instances: form
        .getFieldValue("instances")
        .map((item: any) => Number(item)),
      config: YAML.parse(form.getFieldValue("config")),
    };
    if (currentConfiguration?.id != null) {
      return await dispatch(
        updatePacketConfigurationAsync(newPacketConfiguration),
      );
    } else {
      return await dispatch(
        createPacketConfigurationAsync(newPacketConfiguration),
      );
    }
  };

  const ChangeConfiValue = (): void => {
    try {
      // TODO: Should take into account selected modules
      form.setFieldValue("config", configTemplateBuilder());
    } catch (err) {}
  };

  return (
    <>
      <PageHeader
        style={{
          padding: 0,
          marginBottom: "1.25rem",
          borderBottom: "1px solid #d9d9d9",
        }}
        className="site-page-header"
        onBack={() => {
          navigate("/admin/configuration");
        }}
        title={
          currentConfiguration == null
            ? "Новая пакетная конфигурация"
            : currentConfiguration.name
        }
        extra={
          <>
            {currentConfiguration?.id != null ? (
              <DeployButtonWithConfirm
                configurationId={currentConfiguration.id}
                isDataTouched={form.isFieldsTouched()}
              />
            ) : (
              <></>
            )}
            <Button
              onClick={() => {
                console.log("onClick");
                form.submit();
              }}
              key={"saveButton"}
              type="primary"
            >
              {currentConfiguration?.id != null ? "Сохранить" : "Создать"}
            </Button>
          </>
        }
      />

      <Form
        key={currentConfiguration?.id}
        form={form}
        layout="horizontal"
        onFinish={() => {
          createNewConfig();
        }}
        initialValues={{
          domain: "partner",
          // network: currentConfiguration?.net ?? "",
        }}
      >
        <Form.Item
          required
          label="Название"
          name="name"
          rules={[
            { required: true, message: "Необходимо определить название" },
          ]}
        >
          <Input maxLength={200} showCount style={{ width: "30%" }} />
        </Form.Item>
        <Form.Item
          required
          label="Домен"
          name="domain"
          rules={[{ required: true, message: "Необходимо определить домен" }]}
        >
          <Segmented options={["partner", "gamma", "orbit"]} />
        </Form.Item>
        <Form.Item
          label="Клиент"
          name="network"
          rules={[{ required: true, message: "Необходимо определить клиента" }]}
        >
          <AutoCompleteClient
            initValue={currentConfiguration?.network}
            domain={domain}
          />
        </Form.Item>
        <Divider orientation="left" plain>
          Выбор устройств
        </Divider>
        <Form.Item name="instances">
          <InstancesTransfer domain={domain} networkId={network?.id} />
        </Form.Item>
        <Divider orientation="left" plain>
          Конфигурация
        </Divider>
        <Row style={{ marginBottom: "1rem" }}>
          <Col flex="auto">
            <Select
              mode="multiple"
              placeholder="Какие модули включить в шаблон"
              value={selectedItems}
              onChange={setSelectedItems}
              style={{ width: "100%" }}
              options={filteredOptions.map((item) => ({
                value: item,
                label: item,
              }))}
            />
          </Col>
          <Col flex="none">
            <Button
              onClick={() => {
                ChangeConfiValue();
              }}
            >
              {" "}
              Сгенерировать шаблон {<ToolOutlined />}
            </Button>
          </Col>
        </Row>

        <Form.Item
          name="config"
          required
          validateFirst
          rules={[
            { required: true, message: "Необходимо определить конфигурацию" },
            { validator: yamlValidate },
          ]}
        >
          <CodeEditor
            language="yaml"
            placeholder="Заполните параметры метода"
            padding={15}
            data-color-mode="light"
            style={{
              borderRadius: "2px",
              fontSize: 14,
              backgroundColor: "white",
              fontFamily:
                "ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace",
            }}
          />
        </Form.Item>
      </Form>
    </>
  );
};
